import { useCompletionHistoryCustomFilters, useReduxState } from 'hooks';
import { Filters } from 'components/common/filter';
import { AnalyticsCompletionHistoryTable, AnalyticsPageFilters } from '.';

const AnalyticsCompletionHistory = () => {
  const { messages } = useReduxState();

  return (
    <div>
      <AnalyticsPageFilters
        additionalFilterIds={['completion-history']}
        includeSearch="searchTitle"
        includeSearchPlaceholder={messages.searchTitleCompletion}
      >
        <Filters
          filters={{}}
          customFilters={useCompletionHistoryCustomFilters()}
          filterId="completion-history"
          triggerProps={{
            icon: 'certificate' as const,
            text: messages.analyticsFilterCompletions
          }}
        />
      </AnalyticsPageFilters>

      <AnalyticsCompletionHistoryTable />
    </div>
  );
};

export default AnalyticsCompletionHistory;
